module.exports = __webpack_public_path__ + "img/3.2c6d2bc1.jpg";